import styled from 'styled-components';

export const CompletionHeader = styled.h2`
  font-size: 1.125rem !important;
  margin: 0;
`;

export const CompletionHeaderLarge = styled.h2`
  font-size: 1.5rem !important;
  margin: 0;
`;
